import { useTranslation } from 'react-i18next'

import { cn } from '../../../../lib/utils'
import { GradientOrb } from './GradientOrb'
import { NODE_STATUS_OVERLAY_CLASS } from './NodeStatusMessage'

type NodeDownloadPreparingBannerProps = {
  className?: string
}

/**
 * RFC-1612: shown on a video node while its video is C2PA-signed for download.
 *
 * Sits in the node's status-message slot (the strip over the bottom of the
 * preview) and takes priority over any status message there: the caller renders
 * this instead of `NodeStatusMessage` while signing runs.
 */
export function NodeDownloadPreparingBanner({ className }: NodeDownloadPreparingBannerProps) {
  const { t } = useTranslation('canvas')
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(NODE_STATUS_OVERLAY_CLASS, 'flex items-center gap-2', className)}
      data-testid="video-download-preparing"
    >
      <GradientOrb size={16} />
      <span className="min-w-0 truncate text-xs text-foreground/85">
        {t('videoPreviewPlayer.preparingDownload')}
      </span>
    </div>
  )
}
